import { render } from "./cta.vue?vue&type=template&id=19c8aa72&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=19c8aa72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19c8aa72"

export default script